export default __webpack_public_path__ + "static/brinde-2400936f33a90f98e984abbecba0910f.png";